import React from 'react';
import { FaLightbulb, FaMoon } from 'react-icons/fa';

import { useTheme } from '../../context/ThemeContext';

const SwitcherHeader = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button onClick={toggleTheme} aria-label="Toggle theme">
      <span className="setColor dark" aria-hidden="true">
        <FaLightbulb />
      </span>
      <span className="setColor light" aria-hidden="true">
        <FaMoon />
      </span>
      <span className="visually-hidden">{theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}</span>
    </button>
  );
};

export default SwitcherHeader;